import { render } from "./statistical-panel.vue?vue&type=template&id=7ae552e0&scoped=true&ts=true"
import script from "./statistical-panel.vue?vue&type=script&lang=ts"
export * from "./statistical-panel.vue?vue&type=script&lang=ts"

import "./statistical-panel.vue?vue&type=style&index=0&id=7ae552e0&scoped=true&lang=less"

import exportComponent from "/home/runner/work/vue3-admin/vue3-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae552e0"]])

export default __exports__